import React from 'react'
import PropTypes from 'prop-types'
import { browserHistory } from 'react-router'
import { Card, CardActions, CardHeader, CardText } from 'material-ui/Card'
import { Table, TableBody, TableRow, TableRowColumn } from 'material-ui/Table'
import RaisedButton from 'material-ui/RaisedButton'
import get from 'lodash/get'

import api from '../../../api'
import { setSnackbarMessage } from '../../../actions/snackbar'
import store from '../../../store'
import { formatDateTime } from '../../../formatters'
import withFileExport from './withFileExport'

class Invoice extends React.Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {}
    this.handleExport = this.handleExport.bind(this)
  }

  componentWillMount () {
    const { order } = this.props
    this.loadInvoice(order)
  }

  componentWillReceiveProps ({ order }) {
    this.loadInvoice(order)
  }

  loadInvoice (order) {
    const { invoice } = this.state

    if (invoice && invoice.order_id !== order.id) {
      this.setState({ invoice: null })
    }

    return api.get(`admin/orders/${order.id}/invoice`, {
      acceptableStatuses: [404]
    }).then(res => {
      if (res.status === 404) {
        return null
      }

      return res.json()
    }).then(invoice => {
      this.setState({ invoice })
      return invoice
    })
  }

  invoiceOrder = () => {
    const { order } = this.props

    return api.post(`admin/orders/${order.id}/invoice`)
      .then(res => {
        if (res.status === 400) {
          return res.json().then(error => {
            this.setState({ error })
            store.dispatch(setSnackbarMessage('Could not send invoice'))
          })
        }

        return res.json().then(invoice => {
          store.dispatch(setSnackbarMessage('Invoice has been sent'))
          this.setState({ invoice })
          this.props.onOrderChanged()
        })
      })
  }

  handleExport () {
    const { order, requestExport } = this.props
    const path = `admin/orders/${order.id}/invoice/export`
    return requestExport(path)
  }

  render () {
    const { exportError, order } = this.props
    const { invoice, error } = this.state

    const invoiceCreatedAt = invoice && invoice.created_at ? formatDateTime(invoice.created_at) : 'never'
    const lastSent = invoice && invoice.last_sent_at ? formatDateTime(invoice.last_sent_at) : 'never'

    if (!order.is_invoiceable) {
      return null
    }

    const title = 'Invoice Details'

    return (
      <Card>
        <CardHeader title={title} />
        {invoice
          ? <CardText>
            <Table selectable={false}>
              <TableBody displayRowCheckbox={false}>
                <TableRow>
                  <TableRowColumn>Invoice Number</TableRowColumn>
                  <TableRowColumn>{invoice.id}</TableRowColumn>
                </TableRow>
                <TableRow>
                  <TableRowColumn>Invoice Created At</TableRowColumn>
                  <TableRowColumn>{invoiceCreatedAt}</TableRowColumn>
                </TableRow>
                <TableRow>
                  <TableRowColumn>Adjusted Invoice Date</TableRowColumn>
                  <TableRowColumn>{invoice && formatDateTime(invoice.adjusted_invoice_date)}</TableRowColumn>
                </TableRow>
                <TableRow>
                  <TableRowColumn>Last Sent</TableRowColumn>
                  <TableRowColumn>{lastSent}</TableRowColumn>
                </TableRow>
                {/* TODO: combine ternary operators and use fragments once react is updated to at least 16.2 in the project */}
                {invoice.payer_billing_name
                  ? <TableRow>
                    <TableRowColumn>Billing Contact Name</TableRowColumn>
                    <TableRowColumn>{invoice.payer_billing_name}</TableRowColumn>
                  </TableRow>
                  : ''}
                {invoice.payer_billing_email
                  ? <TableRow>
                    <TableRowColumn>Billing Contact Email</TableRowColumn>
                    <TableRowColumn>{invoice.payer_billing_email}</TableRowColumn>
                  </TableRow>
                  : ''}
                {invoice.payer_institution
                  ? <TableRow>
                    <TableRowColumn>Institution</TableRowColumn>
                    <TableRowColumn>{invoice.payer_institution}</TableRowColumn>
                  </TableRow>
                  : ''}
                {invoice.payer_address_line_1
                  ? <TableRow>
                    <TableRowColumn>Address Line 1</TableRowColumn>
                    <TableRowColumn>{invoice.payer_address_line_1}</TableRowColumn>
                  </TableRow>
                  : ''}
                {invoice.payer_address_line_2
                  ? <TableRow>
                    <TableRowColumn>Address Line 2</TableRowColumn>
                    <TableRowColumn>{invoice.payer_address_line_2}</TableRowColumn>
                  </TableRow>
                  : ''}
                {invoice.payer_city
                  ? <TableRow>
                    <TableRowColumn>City</TableRowColumn>
                    <TableRowColumn>{invoice.payer_city}</TableRowColumn>
                  </TableRow>
                  : ''}
                {invoice.payer_country
                  ? <TableRow>
                    <TableRowColumn>Country</TableRowColumn>
                    <TableRowColumn>{invoice.payer_country}</TableRowColumn>
                  </TableRow>
                  : ''}
                {invoice.payer_state
                  ? <TableRow>
                    <TableRowColumn>State</TableRowColumn>
                    <TableRowColumn>{invoice.payer_state}</TableRowColumn>
                  </TableRow>
                  : ''}
                {invoice.payer_postal_code
                  ? <TableRow>
                    <TableRowColumn>Postal Code</TableRowColumn>
                    <TableRowColumn>{invoice.payer_postal_code}</TableRowColumn>
                  </TableRow>
                  : ''}
              </TableBody>
            </Table>
          </CardText>
          : ''}

        {
          error || (exportError && (
            <CardText color='red'>
              Error: {get(error, 'message') || get(exportError, 'message')}
            </CardText>
          ))
        }
        <CardActions>
          <RaisedButton
            primary
            label={`${invoice ? 'Re-send' : 'Send'} invoice`}
            onClick={this.invoiceOrder}
          />
          <RaisedButton
            secondary
            label='Export PDF'
            onClick={this.handleExport}
          />
          {invoice && (
            <RaisedButton
              label='Edit Invoice'
              onClick={() => browserHistory.push(`/ecommerce/orders/${order.id}/invoice`)}
            />
          )}
        </CardActions>
      </Card>
    )
  }
}

// @ts-ignore
Invoice.propTypes = {
  exportError: PropTypes.object,
  order: PropTypes.object
}

export default withFileExport(Invoice)
